import React, { Component } from "react";
import classnames from "classnames";

import { ITestableComponentProps } from "@formant/core/model/ITestableComponentProps";

import * as styles from "./LinkList.scss";

export interface ILinkListProps extends ITestableComponentProps {
    className?: string;
    children?: React.ReactNode;
}

export class LinkList extends Component<ILinkListProps> {
    public render() {
        const { className, children } = this.props;

        return (
            <div
                className={classnames(styles["link-list"], className)}
                data-testid={this.props["data-testid"]}
            >
                {children}
            </div>
        );
    }
}
